import React from 'react';
import Skeleton from './Skeleton';

const ProductCarouselSkeleton = ({ slides = 4 }) => (
  <div className="product-carousel-skeleton" aria-hidden="true">
    <div className="product-carousel-skeleton-row">
      {[...Array(slides)].map((_, idx) => (
        <div key={idx} className="product-carousel-skeleton-card">
          <Skeleton className="product-carousel-skeleton-image" height="auto" borderRadius="12px" />
          <Skeleton width="78%" height="0.8rem" style={{ marginBottom: 6 }} />
          <Skeleton width="42%" height="1.05rem" />
        </div>
      ))}
    </div>
  </div>
);

export default ProductCarouselSkeleton;

